// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","main":"App_main__5VZ13","he":"App_he__Gk1+h","skipLink":"App_skipLink__s3fxj"};